import React, { createContext, useContext, useState } from 'react';
export type Country = 'CA' | 'US';
type CountryContextValue = {
  country: Country;
  setCountry: (country: Country) => void;
};
const CountryContext = createContext<CountryContextValue>({
  country: 'CA',
  setCountry: () => {}
});
export function CountryProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [country, setCountry] = useState<Country>('CA');
  return <CountryContext.Provider value={{
    country,
    setCountry
  }} data-id="element-642" data-mp="1ayzrfg6kis4t">
      {children}
    </CountryContext.Provider>;
}
export function useCountry() {
  return useContext(CountryContext);
}